module.exports = __webpack_public_path__ + "static/media/me.f9142437.jpg";